export interface BiEvent {
  evid: number;
  /** helper while migrating, do not pass manually */
  _biLoggerVersion?: 2;
  /**  prop for internal use to calculate selected option in <select /> */
  _value?: string;
  /** prop for internal use to calculate rank */
  _rankIndex?: number;
}

/** BiData that does not allow contextual data, use this outside of components */
export function PureBiData<T extends BiEvent>(data: T): T {
  return { ...data, _biLoggerVersion: 2 };
}
